import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import generateClassesFromMap from '@insight/toolkit-utils/lib/generators/generateClassesFromMap';
import { t } from '@insight/toolkit-utils/lib/labels';

import Icon from '../Icon/Icon';

import { LOADING_SIZES, LOADING_CLASS_MAP } from './classes';

const Loading = ({ children, className, size, ...rest }) => {
  const derivedClasses = generateClassesFromMap({ size }, LOADING_CLASS_MAP);
  const classes = cn('c-loading', derivedClasses, className);
  return (
    <div className={classes} {...rest}>
      <Icon className="c-loading__icon" icon="load-c" title={t('Loading...')} />
      {children}
    </div>
  );
};

export default Loading;

/* eslint-disable react/require-default-props */
Loading.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(LOADING_SIZES),
};

Loading.defaultProps = {
  children: null,
  className: '',
};
/* eslint-disable react/require-default-props */
